module.exports = __webpack_public_path__ + "static/media/coverageThings2.db9fd86c.png";